var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgTestTubeLine = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 63,
    viewBox: "0 0 63 63",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.625 5.25V10.5H42V47.25C42 53.0489 37.2989 57.75 31.5 57.75C25.701 57.75 21 53.0489 21 47.25V10.5H18.375V5.25H44.625ZM36.75 26.25H26.25V47.25C26.25 50.1496 28.6004 52.5 31.5 52.5C34.3996 52.5 36.75 50.1496 36.75 47.25V26.25ZM34.125 39.375C35.5748 39.375 36.75 40.5502 36.75 42C36.75 43.4498 35.5748 44.625 34.125 44.625C32.6752 44.625 31.5 43.4498 31.5 42C31.5 40.5502 32.6752 39.375 34.125 39.375ZM28.875 31.5C30.3248 31.5 31.5 32.6752 31.5 34.125C31.5 35.5748 30.3248 36.75 28.875 36.75C27.4252 36.75 26.25 35.5748 26.25 34.125C26.25 32.6752 27.4252 31.5 28.875 31.5ZM36.75 10.5H26.25V21H36.75V10.5Z",
    fill: "#BFD6D2"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTestTubeLine, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/test-tube-line.77b2e337.svg";
export { ForwardRef as ReactComponent };